import React, { useEffect, useState } from 'react';
import SportSection from './SportSection';
import MyBets from './MyBets';
import AllBets from './AllBets';
import SportsList from './SportsList';
import Betslip from './Betslip';
import Header from './header';
import { fetchAndSaveScores } from '../database/Functions';
import { useAuth } from '../context/AuthContext';
import { awardMyActiveBets, removeCompletedBetsById } from '../database/Functions';
import Notifications from './Notifications';
import BetslipItem from './BetslipItem';
import Settings from './Settings';

function Main() {
  const [currentView, setCurrentView] = useState('home'); // Default view
  const [selectedBet, setSelectedBet] = useState(null);
  const { currentUser, userProfile } = useAuth();
  const [selectedSportKeys, setSelectedSportKeys] = useState('all');
  const [selectedSportTitle, setSelectedSportTitle] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [showNotifications, setShowNotifications] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // 768px is typical md breakpoint
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSummaryClick = () => {
    if (selectedBet) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSportSelect = async (sportsKey, title) => {
    if(currentView !== "home"){
      setCurrentView("home")
    }
    if(selectedSportKeys === "All" || selectedSportKeys === "all" ){
      /* console.log("fetching from fb")
      const sportKeys = ['mma_mixed_martial_arts','americanfootball_ncaaf', 'baseball_mlb', 'basketball_nba', 'boxing_boxing', 'americanfootball_nfl']
      for(const key of sportKeys){
        await fetchAndSaveScores(key);
      } */
    }
    
    setSelectedSportKeys(sportsKey || ["all"]);
    setSelectedSportTitle(title || ["All"]);
  };

  useEffect(() => {
    if(currentUser){
      removeCompletedBetsById(currentUser.uid);
      awardMyActiveBets(currentUser.uid)
    }  
  }, [currentUser])

  useEffect(() => {
    if (selectedBet) {
      setIsModalOpen(true);
    }
  }, [selectedBet]);

  const renderContent = () => {
    if (currentView === 'home') {
      return (
        <SportSection
          onSelectBet={setSelectedBet}
          onSelectedSportKeysFromList={selectedSportKeys || "all"}
          onSelectedSportTitleFromList={selectedSportTitle || "All"}
          searchQuery={searchQuery}
          onSearchQueryChange={setSearchQuery}
        />
      );
    } 
    else if (currentView === 'myBets') {
      return <MyBets onCreateBet={() => setCurrentView("home")} />;
    } else if (currentView === 'allBets') {
      return <AllBets onCreateBet={() => setCurrentView("home")} />;
    } else if (currentView === 'settings') {
      return <Settings />;
    }
     else {
      return <SportSection onSelectBet={setSelectedBet} searchQuery={searchQuery} onSearchQueryChange={setSearchQuery} />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-gray-900 to-black text-white">
      <Header onToggle={setCurrentView} currentView={currentView} onShowNotifications={setShowNotifications} />

      {showNotifications && 
        <div className=''>
          <Notifications isOverlay={true} onClose={() => setShowNotifications(false)} />
        </div>
      }

      <div className="flex flex-grow">
        {/* Sidebar with SportsList */}
        <div className="w-[250px] min-w-[250px] py-4 px-2 hidden md:block">
          <SportsList onSelectSport={handleSportSelect} onSearch={setSearchQuery} />
        </div>

        {/* Main Content */}
        <div className="flex-grow py-4 px-2 md:px-4 overflow-auto overflow-y-clip">
          {renderContent()}
        </div>

        {/* Betslip on the right */}
        <div className="w-[300px] min-w-[300px] xl:w-[340px] xl:min-w-[340px] py-4 px-2 hidden md:block">
          <Betslip selectedBet={selectedBet} />
        </div>

        {isModalOpen && selectedBet && (
          <div className='fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center'>
            <div className='bg-gray-900/90 p-6 rounded-xl w-full max-w-md relative border border-gray-800 shadow-xl'>
              <button 
                className='absolute top-3 right-3 text-gray-400 hover:text-white bg-gray-800/70 rounded-full w-8 h-8 flex items-center justify-center transition-colors z-[60]'
                onClick={handleCloseModal}
              >
                ✕
              </button>
              <BetslipItem bet={selectedBet} />
            </div>
          </div>
        )}
        
        {selectedBet && (
          <div 
            className='fixed bottom-0 left-0 right-0 w-full bg-emerald-500 text-white p-3 text-center cursor-pointer text-sm md:hidden shadow-lg'
            onClick={handleSummaryClick}
          >
            <p className="font-medium">Selected Bet: {selectedBet.home_team} vs {selectedBet.away_team}</p>
            <p className="text-xs mt-1">Tap to place your bet</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Main;
